export default __webpack_public_path__ + "media/src/assets/images/reportMenu-8c5de906735c2a61247fb3c9baab3c8d.png";